/**
 * Copy text to the clipboard. `done` runs only when the text was actually copied: through the async Clipboard
 * API, or (no clipboard in a non-secure context, or a rejected write) the old execCommand('copy') on a hidden
 * textarea. When both fail, `failed` runs instead, so a caller never says "Copied" when nothing was copied.
 */
export function copyText(t: string, done: () => void, failed?: () => void) {
  const fallback = () => {
    let ok = false;
    const a = document.createElement('textarea');
    a.value = t;
    a.setAttribute('readonly', '');
    a.style.position = 'fixed';
    a.style.opacity = '0';
    document.body.appendChild(a);
    a.select();
    try {
      ok = document.execCommand('copy');
    } catch {
      ok = false;
    }
    a.remove();
    if (ok) done();
    else failed?.();
  };
  try {
    if (!navigator.clipboard?.writeText) return fallback();
    navigator.clipboard.writeText(t).then(done, fallback);
  } catch {
    fallback();
  }
}

/** What to say when nothing could be copied. */
export const COPY_FAILED = 'Could not copy. Select the text and copy it yourself.';
